import * as tslib_1 from "tslib";
import { OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';
import { PhotoPosition } from '../../../models/trofaco/plantingSiteDetailDto';
import { FrontendRouteService } from '../frontend-route.service';
import { AgmMap } from '@agm/core';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { ModalPlantingSiteDetailsComponent } from './modal-planting-site-details/modal-planting-site-details/modal-planting-site-details.component';
export class TotalSpecies {
}
export class PlantingSiteDetailsComponent {
    constructor(frontendRoute, appConfig, _modalService) {
        this.frontendRoute = frontendRoute;
        this.appConfig = appConfig;
        this._modalService = _modalService;
        this.positionEnum = PhotoPosition;
        this.availableIcon = 'assets/img/map-icons/map-m-green.png';
        this.notAvailableIcon = 'assets/img/map-icons/map-m-red.png';
        this.labelBar = 'assets/img/map-icons/bar-label.png';
        this.documentMap = [];
        this.totalTrees = 0;
        this.siteSpecies = [];
        this.uniqCertificates = [];
        this.mapTypeId = 'hybrid';
        this.groupCertificate = {};
        this.tabChanged = false;
        this.collapseActive = false;
        this.isCollapsed1 = true;
        this.selectedYear = 'ALL';
        this.yearTabs = [];
        this.filteredAreas = [];
        this.nowDate = new Date().getTime();
        this.showAgmMarker = false;
        this.totalSpecies = [];
    }
    onResize(event) {
        this.showSwipe();
        this.toggleDocumentButton();
    }
    ngOnInit() {
        this.frontendRoute.currentSite$.subscribe(s => this.site = s);
        this.frontendRoute.currentPlantingSiteArea$.subscribe(s => this.siteArea = s);
        this.singleDonorMessage = this.site.singleDonorMessage;
        if (this.siteArea) {
            this.mapDocument();
            this.sortCollectionByDate();
            this.handleTreesAndCertificateData();
            this.getTotalSpecies(this.siteSpecies);
        }
        else {
            this.getYearTabs();
            this.filterAreas();
        }
        var banner = sessionStorage.getItem('PlantingNoti_' + this.site.id);
        if (banner) {
            var isTrue = (banner === 'true');
            this.isShowBanner = isTrue;
        }
        else {
            sessionStorage.setItem('PlantingNoti_' + this.site.id, "true");
            this.isShowBanner = true;
        }
    }
    handleTreesAndCertificateData() {
        this.handleTreesData();
        this.handleCertificates();
    }
    handleTreesData() {
        this.totalTrees = 0;
        this.siteSpecies = [];
        if (this.siteArea) {
            this.totalTrees = this.siteArea.totalTrees;
            this.siteSpecies = this.siteArea.species;
        }
        else {
            if (this.selectedYear == 'ALL') {
                this.totalTrees = this.site.totalTrees;
            }
            else {
                this.filteredAreas.forEach(area => {
                    this.totalTrees += area.totalTrees;
                });
            }
            this.filteredAreas.forEach(area => {
                this.siteSpecies = [...this.siteSpecies, ...area.species];
            });
            let speciesSum = this.siteSpecies.reduce((previousValue, currentValue) => currentValue.count + previousValue, 0);
            let species = [
                ...this.siteSpecies
            ];
            this.getTotalSpecies(species);
            if (this.selectedYear == 'ALL') {
                species.unshift({ species: 'Miscellaneous', count: this.site.totalTrees - speciesSum });
            }
            this.siteSpecies = species.filter(s => s.count > 0);
        }
    }
    handleCertificates() {
        this.groupCertificate = this.groupByCertByCustomerId(this.site.certificates);
        this.uniqCertificates = this.getUniqCerByCustomer();
    }
    ngAfterViewInit() {
        this.showSwipe();
        this.toggleDocumentButton();
    }
    ngAfterViewChecked() {
        if (this.tabChanged) {
            this.toggleDocumentButton();
        }
    }
    getUniqCerByCustomer() {
        const result = [];
        const map = new Map();
        let certificates = [];
        if (this.siteArea) {
            certificates = this.siteArea.certificates;
        }
        else if (this.selectedYear == 'ALL') {
            certificates = this.site.certificates;
        }
        else {
            this.filteredAreas.forEach(area => {
                certificates = [...certificates, ...this.site.certificates.filter(f => f.plantingSiteAreaId === area.id)];
            });
        }
        for (const cer of certificates) {
            if (!map.has(cer.customerId)) {
                map.set(cer.customerId, true); // set any value to Map
                result.push(cer);
            }
        }
        return result;
    }
    groupByCertByCustomerId(target) {
        return target.reduce((total, current) => {
            total[current.customerId] = total[current.customerId] || [];
            total[current.customerId].push(current);
            return total;
        }, Object.create(null));
    }
    mapDocument() {
        this.documentMap = [
            ...this.siteArea.collections.map(m => ({ type: 'photo', date: m.date, obj: m })),
            ...this.siteArea.videos.map(m => ({ type: 'video', date: m.date, obj: m }))
        ];
        this.documentMap = ArrayHelper.sortBy(this.documentMap, false, doc => doc.date);
    }
    sortCollectionByDate() {
        this.site.collections = ArrayHelper.sortBy(this.site.collections, false, coll => coll.date);
    }
    getYearTabs() {
        this.yearTabs = [...new Set(this.site.areas.map(m => m.year).sort((a, b) => b - a))];
    }
    filterAreas() {
        this.filteredAreas = this.selectedYear == 'ALL' ? this.site.areas : this.site.areas.filter(f => f.year.toString() == this.selectedYear);
        this.filteredAreas = ArrayHelper.sortBy(this.filteredAreas, false, area => area.year);
        this.handleTreesAndCertificateData();
    }
    checkFitBounds() {
        if (this.selectedYear === 'ALL') {
            this.showAgmMarker = true;
            return true;
        }
        if (this.filteredAreas.length === 0) {
            this.showAgmMarker = false;
        }
        else if (this.filteredAreas.length === 1) {
            this.showAgmMarker = this.filteredAreas[0].kmlAreaProperties.length == 0;
        }
        else {
            this.showAgmMarker = !this.filteredAreas.some(area => area.kmlAreaProperties.length > 0);
        }
        return true;
    }
    changeFilterYear(year) {
        this.totalSpecies = [];
        this.selectedYear = year;
        this.filterAreas();
        this.toggleDocumentButton();
    }
    openModal(isLandOwner, ngoPartner, plantingSiteSpecies) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!isLandOwner) {
                this.ngoPartnerModal = ngoPartner;
            }
            const initialState = {
                site: this.site,
                isLandOwner: isLandOwner,
                ngoPartner: this.ngoPartnerModal,
                plantingSiteSpecies: plantingSiteSpecies
            };
            this.modalRef = this._modalService.show(ModalPlantingSiteDetailsComponent, {
                class: "modal-lg modal-dialog-centered  partner-details",
                initialState,
            });
        });
    }
    onDownloadPDF(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const nameData = data.split('/').reverse()[0];
            const iframe = document.createElement('a');
            iframe.setAttribute('target', '_blank');
            iframe.setAttribute('href', `${data}`);
            iframe.setAttribute('download', `${nameData}`);
            document.body.appendChild(iframe);
            iframe.click();
            iframe.remove();
        });
    }
    getSampleThumbnail(area) {
        if (!area.collections || area.collections.filter(f => f.thumbnailPhotoId).length == 0)
            return undefined;
        return area.collections.filter(f => f.thumbnailPhotoId)[0];
    }
    showSwipe() {
        var navTabs = document.getElementsByClassName('nav-tabs');
        if (!navTabs || navTabs.length == 0)
            return;
        var tabs = document.getElementById('tabs');
        var scrollWidth = navTabs[0].scrollWidth;
        var clientWidth = navTabs[0].clientWidth;
        if (scrollWidth > clientWidth) {
            tabs.classList.add('swipe');
        }
        else {
            tabs.classList.remove('swipe');
        }
    }
    toggleDocumentButton() {
        const element = document.getElementById('collapseBasic');
        if (!element)
            return;
        let showCollapseBtn = false;
        const windowWidth = window.innerWidth;
        if (windowWidth < 575 && this.filteredAreas.length > 3) {
            showCollapseBtn = true;
        }
        else if (windowWidth < 765 && this.filteredAreas.length > 6) {
            showCollapseBtn = true;
        }
        else if (windowWidth < 990 && this.filteredAreas.length > 9) {
            showCollapseBtn = true;
        }
        else if (this.filteredAreas.length > 12) {
            showCollapseBtn = true;
        }
        if (showCollapseBtn) {
            element.classList.add('show-button');
        }
        else {
            element.classList.remove('show-button');
        }
        this.tabChanged = false;
    }
    hideBanner() {
        sessionStorage.setItem('PlantingNoti_' + this.site.id, "false");
        this.isShowBanner = false;
    }
    getTotalSpecies(siteAllSpecies) {
        const namesSpecies = siteAllSpecies.map(item => item.species).filter((value, index, self) => self.indexOf(value) === index);
        for (let specie of namesSpecies) {
            const countSpecie = siteAllSpecies.filter(item => item.species === specie);
            let total = 0;
            let photoUrl = "";
            let description = "";
            for (let item of countSpecie) {
                total += item.count;
                if (item.photoUrl != null) {
                    photoUrl = item.photoUrl;
                }
                photoUrl = item.photoUrl;
                description = item.description;
            }
            this.totalSpecies.push({
                species: specie,
                count: total,
                photoUrl: photoUrl,
                description: description
            });
        }
    }
}
